export default __webpack_public_path__ + "afe431c11c2f3dec2921120c36bac79b.svg";